<template>
  <section id="header" class="flex bg-white px-10 py-2 shadow-md items-center">
    <div class="logo leading-5">
      PROJECT SUNDEVIL
    </div>
    <nav v-if="$store.state.userData != null">
      <select v-model="routePath">
        <option value="/credentials">Auth Credentials</option>
        <!-- <option value="/permissions" v-if="$store.getters.isAdmin == true">Group Permissions</option> -->
        <option value="/automations">Automation Jobs</option>
      </select>
      <div class="account">
        <label class="mr-4">{{ $store.state.userData.user.name }}</label>
        <a class="button" @click="$store.commit('logout')">Logout</a>
      </div>
      <div class="links">
        <a href="https://app.trainual.com/infotrust/steps/13865638" target="_blank"><img
            :src="require('./assets/trainual-icon.png')" alt="Trainual"></a>
      </div>
      <!-- <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link> -->
    </nav>
  </section>
  <n-config-provider :theme="theme">
    <n-message-provider>
      <n-dialog-provider>
        <router-view />
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script>
import Cookies from 'js-cookie'
import { NDialogProvider, NMessageProvider, NConfigProvider } from 'naive-ui';

export default {
  name: 'App',
  components: {
    NDialogProvider,
    NMessageProvider,
    NConfigProvider
  },
  computed: {
    routePath: {
      get() {
        return this.$route.path;
      },
      set(newVal) {
        this.$router.push(newVal)
      }
    }
  },
  data() {
    return {
      page: null,
      theme: null//darkTheme
    };
  },
  created() {
    var scripts = [
      "https://kit.fontawesome.com/746a661036.js"
    ];
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.head.appendChild(tag);
    });
    if (typeof Cookies.get('userData') != 'undefined') {
      this.$store.commit('setUserData', JSON.parse(Cookies.get('userData')));
    }
  },
  updated() {
    this.page = this.$route.name;
  }
}
</script>

<style lang="scss">
:root {
--n-tab-gap: 1.5rem;
}

$orange: #F45D29;
$red: #d1001f;
$blue: #0C6DC7;

.red {
color: $red;
}

.green {
color: #32a200;
}

.file {

  a {
  color: $blue;

    &:hover {
    color: $blue;
    }

  }

}

.button {
font-weight: 700;
}

.container {
margin: auto;
padding: 3% 5%;
}

#header {

  .logo {
  font-weight: 700;
  color: #000;
  font-size: 2rem;
  padding-right: 2rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-right: 1px solid #ccc;
  }

  nav {
  padding: 30px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1rem;

    a {
    font-weight: bold;
    color: #2c3e50;

      &.router-link-exact-active {
      color: #42b983;
      }

    }

    select {
    padding: 0.75rem 1rem 0.75rem 1rem;
    border: 1px solid #ccc;
    }

    .account {
    margin-right: .5rem;
    margin-left: auto;
    }

    .links {

      a {
      width: 35px;
      display: block;
      border-radius: 5px;
      overflow: hidden;
      }

    }

  }

}

.new {
position: fixed;
top: 0px;
right: 0px;
width: 70%;
height: 100vh;
background: #fff;
box-shadow: -5px 0px 15px rgb(0 0 0 / 15%);
}

.n-form-item-label__text {
font-weight: 700;
}

.n-form-item {

  .description {
  margin-top: 1rem;
  font-style: italic;
  }

  .object {
  width: 100%;

    > .n-form-item {
    border: 1px solid #ececec;
    }

    .n-form-item {
    
      .n-form-item-blank {
      flex-direction: column;
      align-items: flex-start;
      }

    }

  }

}

.n-button--default-type {
background: #0C6DC7;
}

.n-button--warning-type {
background: $red !important;
border: 0px;
}

.n-collapse-item {
background: rgba(250, 250, 252, 1);
padding: 1rem 1rem;
border: 1px solid #eee;
margin: 0px 0px .5rem 0px !important;

  .n-collapse-item__header {
  padding: 0px !important;
  margin: 0px;
  }

}

body h2 {
font-size: 1.5rem;
}

body h3 {
font-size: 1.2rem;
}

body h4 {
font-size: 1.1rem;
}

.n-form {

  .n-form-item {

    .n-form-item-label {
    font-size: 1rem;
    margin-bottom: 1rem;
    }

  }

}

.n-form-item.white-box {
padding: 1rem;
}

.white-box.p-3, .white-box.thin {
padding: 1rem;
}

.n-form-item .n-form-item-feedback-wrapper {
min-height: auto !important;
}

.fa-diamond-exclamation {
color: rgb(244, 93, 41);
}
</style>
